export const partnerThemes = {
  default: {
    themeClass: 'theme-original',
    venueName: "Prost!, Mississippi Ave"
  },
  missionBrewery: {
    themeClass: 'theme-mission',
    venueName: "Mission Brewery, Kensington"
  },
  theHarp: {
    themeClass: 'theme-harp',
    venueName: "The Harp, Ocean Beach"
  },
  beaumonts: {
    themeClass: 'theme-beaumonts',
    venueName: "Beaumont's, La Jolla"
  },
  byrnesPub: {
    themeClass: 'theme-byrnes',
    venueName: "Byrne's Pub, Columbus"
  },
  buckeyes: {
    themeClass: 'theme-buckeyes',
    venueName: "The Shoe, Columbus"
  },
  grossmont: {
    themeClass: 'theme-grossmont',
    venueName: "Grossmont Public, La Mesa"
  },
};

export const themeOptions = [
  { value: 'beaumonts', label: "Beaumont's (Dark)" },
  { value: 'default', label: 'Default (Light)' },
  { value: 'missionBrewery', label: 'Mission Brewery' },
  { value: 'theHarp', label: 'The Harp' },
  { value: 'byrnesPub', label: "Byrne's Pub" },
  { value: 'buckeyes', label: 'Buckeyes' },
  { value: 'grossmont', label: 'Grossmont' },
];

export const emojiPool = ['🥸', '👑', '👽', '🤖', '🤠', '👻', '🦁', '🐙'];
